import { html } from "lit-element"
import { classMap } from "lit-html/directives/class-map"
import Constant from "./constant.js"

/**
 * 日にちセル生成
 */
export default class DateCell {
	constructor (date, currentMonth, currDate, showDate, holidays, calendar, properties) {
		/** @type {Date}  */
		this.date = date
		/** @type {number}  */
		this.currentMonth = currentMonth
		/** @type {Date}  */
		this.currDate = currDate
		/** @type {Date}  */
		this.showDate = showDate
		/** @type {Date[]}  */
		this.holidays = holidays
		/** @type {class} */
		this.calendar = calendar
		/** @type {object} */
		this.properties = properties
	}

	render () {
		return html`
		${this.properties.fix && !this.isCurrentMonth() ? html`<td></td>` : html`
		<td>
			<div class=${this.class} data-value=${this.date} @click="${(e) => { this.selectDate(e) }}">
				<div>${this.date.getDate()}</div>
			</div>
		</td>
		`}
	`
	}

	get class () {
		return classMap({
			"date-cell": true,
			holiday: this.properties.holiday && this.holidays.indexOf(this.date.getTime()) >= 0 && this.isCurrentMonth(),
			sunday: this.properties.emphasisWeekend && this.date.getDay() === 0,
			saturday: this.properties.emphasisWeekend && this.date.getDay() === 6,
			"is-not-current-month": !this.isCurrentMonth(),
			selected: this.isCurrDate(),
			hl: true
		})
	}

	isCurrentMonth () {
		return this.date.getMonth() === this.currentMonth
	}

	isCurrDate () {
		const currDate = new Date(this.currDate.getFullYear(), this.currDate.getMonth(), this.currDate.getDate())
		return this.date.getTime() === currDate.getTime() && this.isCurrentMonth()
	}

	selectDate (e) {
		// 選択日にちを取得
		const date = new Date(e.currentTarget.dataset.value)
		date.setHours(this.calendar.showDate.getHours())
		date.setMinutes(this.calendar.showDate.getMinutes())
		this.calendar.showDate = date
		this.calendar.currDate = date
		// ページ切り替え
		if (this.properties.mode === Constant.MODE.DateTime) {
			this.calendar.page = Constant.MODE.Time
			this.calendar.requestUpdate().then(() => {
				// 選択されている時間を中央に配置する
				this.calendar.centerCurrTime()
			})
		} else {
			this.calendar.settleDate()
		}
	}
}
